<template>
  <div class="mobile-left-sidebar">
    <div class="mobile-left-nav">
      <div class="mobile-left-menu-list">
        <div 
          class="mobile-left-menu-item" 
          v-for="(item, index) in leftMenuItems" 
          :key="index"
          @mouseenter="onMenuEnter(index)" 
          @mouseleave="onMenuLeave()"
        >
          <a @click="handleMenuClick(item)" class="menu-link" href="javascript:void(0)">
            <img 
              :src="hoveredIndex === index ? item.hoverIcon : item.icon" 
              :alt="item.name" 
              class="menu-icon" 
            />
            <span class="menu-text">{{ item.name }}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileLeftSidebar',
  props: {
    leftMenuItems: {
      type: Array,
      required: true,
      default: () => []
    },
    hoveredIndex: {
      type: Number,
      default: null
    },
    user: {
      type: [Object, Array],
      default: () => null
    }
  },
  data() {
    return {
      publicRoutes: ['/main?type=popular', '/main?type=casino', '/main?type=slot', '/main?type=fishing']
    }
  },
  methods: {
    onMenuEnter(index) {
      this.$emit('menu-enter', index)
    },
    onMenuLeave() {
      this.$emit('menu-leave')
    },
    handleMenuClick(item) {
      // Special handling for /playsport - open in new tab
      if (item.path === '/playsport' || item.path === '/playesport') {
        window.open(item.path, '_blank')
        return
      }

      const isPublic = this.publicRoutes.includes(item.path)
      const isLoggedIn = this.user && (Array.isArray(this.user) ? this.user.length > 0 && this.user[0].key : this.user.key)
      
      if (!isPublic && !isLoggedIn) {
        // Show login modal for protected routes when not logged in
        const loginModal = document.getElementById('loginModal')
        if (loginModal) {
          const modal = new bootstrap.Modal(loginModal)
          modal.show()
        } else {
          // Fallback: try jQuery if bootstrap is not available
          if (window.$ && window.$('#loginModal').length) {
            window.$('#loginModal').modal('show')
          } else {
            // Final fallback: trigger modal via data attributes
            const modalTrigger = document.querySelector('[data-target="#loginModal"]')
            if (modalTrigger) {
              modalTrigger.click()
            }
          }
        }
      } else {
        // Navigate to route (either public route or user is logged in)
        this.$router.push(item.path)
      }
    }
  }
}
</script>

<style scoped>
.mobile-left-sidebar {
  width: 80px;
  padding: 10px 5px 5px 15px;
}

.mobile-left-nav {
  display: flex;
  flex-direction: column;
}

.mobile-left-menu-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.mobile-left-menu-item {
  width: 100%;
  height: 90px;
  background: transparent;
  border: none;
  transition: all 0.3s ease;
}

.mobile-left-menu-item:hover {
  transform: translateY(-1px);
}

.menu-link {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: auto;
  text-decoration: none;
  color: #ffffff;
  transition: color 0.3s ease;
}

.menu-link:hover {
  color: #000000;
  text-decoration: none;
  cursor: pointer;
}

.menu-icon {
  width: 60px;
  height: 60px;
  display: block;
  object-fit: contain;
  margin-bottom: 0;
}

.menu-text {
  display: none;
}
</style>
